export const cardTwoTransactionHistoryMockData = [
  {
    id: 27,
    name: "Home Repairs",
    details: "Aiden White",
    amount: 200.0,
    info: "debit",
    timestamp: "2023-09-09T09:15:30Z",
    type: 0,
  },
  {
    id: 28,
    name: "Online Bookstore",
    details: "Zoe Turner",
    amount: 35.8,
    info: "debit",
    timestamp: "2023-09-09T15:45:00Z",
    type: 1,
  },
  {
    id: 29,
    name: "Internet Subscription",
    details: "Ethan Robinson",
    amount: 55.0,
    info: "credit",
    timestamp: "2023-09-08T12:30:45Z",
    type: 2,
  },
  {
    id: 30,
    name: "Car Insurance",
    details: "Ava Garcia",
    amount: 120.0,
    info: "debit",
    timestamp: "2023-09-08T18:20:15Z",
    type: 0,
  },
  {
    id: 31,
    name: "Mobile Phone Upgrade",
    details: "Logan Adams",
    amount: 499.99,
    info: "debit",
    timestamp: "2023-09-07T14:30:30Z",
    type: 1,
  },
  {
    id: 32,
    name: "Dental Checkup",
    details: "Chloe Mitchell",
    amount: 75.0,
    info: "debit",
    timestamp: "2023-09-07T16:45:00Z",
    type: 2,
  },
  {
    id: 33,
    name: "Grocery Shopping",
    details: "Mia Taylor",
    amount: 60.5,
    info: "credit",
    timestamp: "2023-09-06T10:10:45Z",
    type: 0,
  },
  {
    id: 34,
    name: "Tech Conference Registration",
    details: "Lucas Turner",
    amount: 180.0,
    info: "credit",
    timestamp: "2023-09-06T13:25:30Z",
    type: 1,
  },
  {
    id: 35,
    name: "Pet Supplies",
    details: "Harper Wilson",
    amount: 45.0,
    info: "debit",
    timestamp: "2023-09-05T11:40:15Z",
    type: 2,
  },
  {
    id: 36,
    name: "Online Music Streaming",
    details: "Mason Davis",
    amount: 9.99,
    info: "credit",
    timestamp: "2023-09-05T15:55:00Z",
    type: 0,
  },
];
